import React, { useState, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';


function IssueOrRevokeShares() {
  const [qty, setQty] = useState(0)
  const [user, setUser] = useState()
  const [reason, setReason] = useState()

  function parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }



  const location = useLocation();

  useEffect(() => {
    setUser(parseQuery(location.search).user)
  }, [location])

  return (
    <Paper>
      <Container>

        <Box padding={2}>

          {/* Heading */}
          <Box align="left">
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              Issue or Revoke Shares
          </Typography>
          </Box>
          <br />


          {/* Fields */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                display="inline"
                variant="outlined"
                label="Qty Change"
                type="number"
                value={qty}
                onChange={e => setQty(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                variant="outlined"
                label="User"
                type="text"
                onChange={e => setUser(e.target.value)}
                value={user}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                display="inline"
                variant="outlined"
                label="Reason"
                type="text"
                value={reason}
                onChange={e => setReason(e.target.value)}
                required
              />
            </Grid>
          </Grid>
        </Box >

        {/* Submit button */}
        <Box align="right" padding={2} paddingTop={0}>
          <Button variant="contained" color="primary">
            SUBMIT
          </Button>
        </Box>
      </Container>
    </Paper>
  )
}

export default IssueOrRevokeShares
